import { useContext, useEffect, useRef, useState } from "react";
import ShowMyOrder from "./showMyOrder";
import PopUpMsg from "../../../DTechComp/PopUpMsg";
import TopBigSlides from "../../../DTechComp/TopBigSlides";
import ConnUrls from "../../../Connections/ConnectURL";
import { Button, IconButton } from "@mui/material";
import { CheckCircleOutline, ControlPointDuplicate, DeliveryDining, KeyboardDoubleArrowDown, KeyboardDoubleArrowUp, PanoramaFishEye, LocalMallOutlined, TakeoutDining, Visibility, VisibilityOff, ShoppingCartOutlined } from "@mui/icons-material";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import MyDateTime from "../../../DTechComp/MyDateTime";
import { MobiOrNotContext, OrderContext } from "../../../ContextApi/context";
import TheMount from "../../../OrderSettings/TheMount";
import TheWeightSelect from "../../../OrderSettings/TheWeightSelect";

import PopUpOneLine from "../../../DTechComp/PopUpOneLine";



const MyOrderOnCart = (props) => {
    // Use OrderContext directly instead of creating a local copy
    const [order, setOrder] = useContext(OrderContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext)
    const [showClearConfirm, setShowClearConfirm] = useState(false);
    const [thePopUp, setThePopUp] = useState("");
    const [intervalID, setIntervalID] = useState();

    useEffect(() => {

    }, [])

    const handleItemClick = (itemId) => {
        // Close the cart first
        props.setShowCart();

        // Wait for cart to close, then find and click the product block
        setTimeout(() => {
            const productElement = document.getElementById(`prodBlockS_${itemId}`);
            if (productElement) {
                // Create and dispatch a click event
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                productElement.dispatchEvent(clickEvent);
            }
        }, 350); // Wait for cart close animation
    }

    const removeFromOrder = (ordItmId) => {
        // Now this updates the global OrderContext
        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId)
        order.Orders = filt;

        setOrder({ ...order })
    }

    const clearCartCheck = () => {
        setThePopUp(
            <PopUpOneLine
                cssStyl={"specialPopComp onTopOfAll noPadding"}
                key={"popClearCart"}
                topTitle={"ניקוי הסל"}
                Title={["האם בטוח שברצונך לנקות את סל הקניות?"]}
                inLabel={""}
                closeFunc={() => setThePopUp()}
                btn1Clck={() => setThePopUp()}
                btn1Txt={"ביטול"}
                btn2Txt={"כן נקה"}
                btn2Clck={() => {
                    handleClearCart();
                    setThePopUp();
                }}
            />
        )

    }


    const handleClearCart = () => {
        setOrder(OrderFunctions.clearOrd());
        setShowClearConfirm(false);
        props.setShowCart();
    }







    return (
        <div key={props.theOrder.id} className={"overflowHid pointing"}>

            <div className={"theShopCartWrap"} id={`theShopCartWrap`}>

                <div className={"ordDetailsShopCart margTopBig"} id={`ordDetailsShopCartCls_`}>
                    <div className="fullRow overflowHid">
                        <div className={"veryBig bold spaceRightVeryLong onRight"}>סל הקניות</div>
                        <div className={"ButtonMe3 onLeft spaceMargBottomBig spaceMargRightLong"} onClick={() => clearCartCheck()}>
                            <span>נקה סל</span>
                        </div>
                    </div>
                    <br />

                    <div className={"ordDetailsShopCartItems"}>
                        {order.Orders?.map((item, index) => {
                            if (item.mount > 0) {
                                return (

                                    <div key={index} className={"ordItem spaceButtomBig "}>

                                        <div className={"ordItmLine"}>
                                            <div className='col-12 fullRow overflowHid'>
                                                <div className='col-8 onRight overflowHid' onClick={() => handleItemClick(item.ordProdID)}>
                                                    <div className='col-12 overflowHid'>
                                                        <div className='col-2 onRight tdmin10 overflowHid'>
                                                            <span className={"ordItemMount mainMount"}>{item.mount} יח'&nbsp;</span>
                                                        </div>
                                                        <div className='col-6 onRight overflowHid'>
                                                            <span className={"fullRow big"}> {item.productName} </span>
                                                            <span className={"fullRow small"}> {item.prodInfo} </span>
                                                            <span className={"fullRow small"}> {item.unitPrice} </span>
                                                        </div>
                                                        <div className='col-4 onRight overflowHid'>
                                                            <div className={"imgOnCart"}>
                                                                {item.prodImageUrl ? <img src={`${ConnUrls.servMediasUrl}${item.prodImageUrl}`}
                                                                    className={"smallDIspImage"} alt={item.prodName} />
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-4 onRight overflowHid'>
                                                    <span style={{ textAlign: "left", paddingBottom: "10px" }}
                                                        className={"bold col-12 onLeft big"}>
                                                        ₪ {item.weightValue !== undefined
                                                            ? ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2)
                                                            : (parseFloat(item.prodPrice) * parseInt(item.mount)).toFixed(2)
                                                        }
                                                    </span>
                                                    {/* edit mount */}
                                                    <div id={index} className={"col-12 onLeft itemMount"}>
                                                        <span className={"bold itemMountLf"}>
                                                            {item.weightValue !== undefined ? (
                                                                <TheWeightSelect
                                                                    itemId={item.orderItemId}
                                                                    weightValue={item.baseWeightValue || item.weightValue}
                                                                    remFromOrder={() => { removeFromOrder(item.orderItemId) }}
                                                                />
                                                            ) : (
                                                                <TheMount
                                                                    itemId={item.orderItemId}
                                                                    remFromOrder={() => { removeFromOrder(item.orderItemId) }}
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                    {/* Remove button */}
                                                    <div className={"removeItemFromCartBtn"} onClick={() => removeFromOrder(item.orderItemId)}>
                                                        <span>הסר מהסל</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        {OrderFunctions.theItemSpecials(item)}



                                    </div>


                                )
                            }
                        })
                        }
                    </div>

                    <div className="totalOnCart margTopBig">

                        <div className={"ordItmLine totalTxt"}>
                            <div className={"bold totalTxtR"}>פריטים:</div>
                            <div className={"bold totalTxtL"}>{props.counter}</div>
                        </div>

                        <div className={"ordItmLine totalTxt"}>
                            <div className={"bold totalTxtR"}>סכום ההזמנה</div>
                            <div className={"bold totalTxtL"}>{OrderFunctions.getOrderPrice(order).toFixed(2)} ₪ </div>
                        </div>

                        {(order.OrderType == "Deliver") ?
                            <div className={"ordItmLine totalTxt"}>
                                <div className={"bold totalTxtR"}>משלוח</div>
                                <div className={"bold totalTxtL"}>{order.OrderDelPrice} ₪ </div>
                            </div> : ""}

                        {(order.orderKopon && order.orderKopon !== "") &&
                            <div className={"ordItmLine totalTxt"}>
                                <div className={"bold totalTxtR"}>קופון {order.orderKopon.Name}</div>
                                <div className={"bold totalTxtL"}>{order.orderKopon.KoponDiscount}{order.orderKopon.KoponDiscType === '1' ? " ₪" : " %"}</div>
                            </div>}

                        <div className={"ordItmLine totalTxt"}>
                            <div className={"bold totalTxtR"}>סה"כ</div>
                            <div className={"bold totalTxtL"}>{OrderFunctions.getOrderTotalPrice(order).toFixed(2)} ₪ </div>
                        </div>

                    </div>
                    <div style={{ display: "table" }} className={"centerMe overflowHid spaceTopBig"}>
                        <div className={"ButtonMe3 onRight spaceMargBottomBig "} onClick={() => props.continToPay()}>
                            <span>מעבר לתשלום</span>
                        </div>
                        <div className={"ButtonMe3 onRight spaceMargBottomBig spaceMargRightLong"} onClick={() => props.setShowCart()}>
                            <span>להמשיך להזמין</span>
                        </div>
                    </div>
                </div>

            </div>
            {thePopUp}
        </div >

    )

}

export default MyOrderOnCart